import { MS_PER_SECOND } from './date';
export let ExtraServiceChekoutScreen;

(function (ExtraServiceChekoutScreen) {
  ExtraServiceChekoutScreen["Item"] = "item";
  ExtraServiceChekoutScreen["Donate"] = "donate";
  ExtraServiceChekoutScreen["Catalog"] = "catalog";
  ExtraServiceChekoutScreen["Balance"] = "balance";
  ExtraServiceChekoutScreen["NewsFeed"] = "news_feed";
  ExtraServiceChekoutScreen["UserProfile"] = "user_profile";
  ExtraServiceChekoutScreen["MultiplePushUp"] = "multiple_push_up";
  ExtraServiceChekoutScreen["FeaturedCollection"] = "featured_collection";
  ExtraServiceChekoutScreen["MessageList"] = "message_list";
  ExtraServiceChekoutScreen["ViewIssueDetails"] = "view_issue_details";
})(ExtraServiceChekoutScreen || (ExtraServiceChekoutScreen = {}));

export let ExtraServiceCheckoutEntityType;

(function (ExtraServiceCheckoutEntityType) {
  ExtraServiceCheckoutEntityType["DirectDonationOrder"] = "direct_donation_order";
  ExtraServiceCheckoutEntityType["WebviewDirectDonationOrder"] = "webview_direct_donation_order";
  ExtraServiceCheckoutEntityType["MsgThreadReturnLabelOrder"] = "msg_thread_return_label_order";
  ExtraServiceCheckoutEntityType["Unknown"] = "unknown";
})(ExtraServiceCheckoutEntityType || (ExtraServiceCheckoutEntityType = {}));

export let ExtraServicePaymentStatus;

(function (ExtraServicePaymentStatus) {
  ExtraServicePaymentStatus[ExtraServicePaymentStatus["New"] = 0] = "New";
  ExtraServicePaymentStatus[ExtraServicePaymentStatus["Processing"] = 10] = "Processing";
  ExtraServicePaymentStatus[ExtraServicePaymentStatus["Pending"] = 20] = "Pending";
  ExtraServicePaymentStatus[ExtraServicePaymentStatus["Failed"] = 30] = "Failed";
  ExtraServicePaymentStatus[ExtraServicePaymentStatus["Processed"] = 40] = "Processed";
  ExtraServicePaymentStatus[ExtraServicePaymentStatus["Refunded"] = 50] = "Refunded";
})(ExtraServicePaymentStatus || (ExtraServicePaymentStatus = {}));

export let ExtraServiceOrderType;

(function (ExtraServiceOrderType) {
  ExtraServiceOrderType["PushUp"] = "push_up_order";
  ExtraServiceOrderType["ClosetPromotion"] = "closet_promotion_order";
  ExtraServiceOrderType["DirectDonation"] = "direct_donation_order";
  ExtraServiceOrderType["FeaturedCollection"] = "featured_collection_order";
  ExtraServiceOrderType["VasGallery"] = "vas_gallery_order";
  ExtraServiceOrderType["ReturnLabel"] = "return_label_order";
})(ExtraServiceOrderType || (ExtraServiceOrderType = {}));

export const extraServiceOrderTypeToTrackingTypeMap = {
  [ExtraServiceOrderType.PushUp]: 'push_up',
  [ExtraServiceOrderType.ClosetPromotion]: 'closet_promotion',
  [ExtraServiceOrderType.DirectDonation]: 'direct_donation',
  [ExtraServiceOrderType.FeaturedCollection]: 'featured_collection',
  [ExtraServiceOrderType.VasGallery]: 'vas_gallery',
  [ExtraServiceOrderType.ReturnLabel]: 'return_label'
};
export const PAYMENT_POLL_DELAY = MS_PER_SECOND;
/* eslint id-length: 0 */

export const VAS_PENDING_STATE_AB_TEST_EXTENDED_PAYMENT_POLL_DURATION = {
  a: 5 * MS_PER_SECOND,
  b: 15 * MS_PER_SECOND,
  c: 30 * MS_PER_SECOND
};
export let ExtraServiceCheckoutModal;

(function (ExtraServiceCheckoutModal) {
  ExtraServiceCheckoutModal["PreCheckout"] = "preCheckout";
  ExtraServiceCheckoutModal["PreCheckoutHelp"] = "preCheckoutHelp";
  ExtraServiceCheckoutModal["DynamicPricingInfo"] = "dynamicPricingInfo";
  ExtraServiceCheckoutModal["OrderReview"] = "orderReview";
  ExtraServiceCheckoutModal["ValueProposition"] = "valueProposition";
  ExtraServiceCheckoutModal["ValuePreview"] = "valuePreview";
  ExtraServiceCheckoutModal["PayInMethodSelection"] = "payInMethodSelection";
  ExtraServiceCheckoutModal["PaymentConfirmation"] = "paymentConfirmation";
  ExtraServiceCheckoutModal["OrderConfirmation"] = "orderConfirmation";
  ExtraServiceCheckoutModal["PaymentAuth"] = "paymentAuth";
  ExtraServiceCheckoutModal["CreditCardForm"] = "creditCardForm";
  ExtraServiceCheckoutModal["BlikCodeInput"] = "blikCodeInput";
  ExtraServiceCheckoutModal["SalesTaxInfo"] = "salesTaxInfo";
  ExtraServiceCheckoutModal["OrderStatus"] = "orderStatus";
  ExtraServiceCheckoutModal["Checkout"] = "checkout";
  ExtraServiceCheckoutModal["None"] = "none";
})(ExtraServiceCheckoutModal || (ExtraServiceCheckoutModal = {}));

export let ExtraServiceOrderStatus;

(function (ExtraServiceOrderStatus) {
  ExtraServiceOrderStatus["Success"] = "success";
  ExtraServiceOrderStatus["Processing"] = "processing";
  ExtraServiceOrderStatus["Failure"] = "failure";
  ExtraServiceOrderStatus["Idle"] = "idle";
})(ExtraServiceOrderStatus || (ExtraServiceOrderStatus = {}));